import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeDocsTableModule } from 'se-fe-docs-table'

import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SharedFeatureEditPersonaModalModule } from '../lib/shared-feature-edit-persona-modal.module'
import { EditPersonaModalDocsComponent } from './edit-persona-modal-docs/edit-persona-modal-docs.component'
import { EditPersonaModalChildExampleComponent } from './edit-persona-modal-docs/examples/edit-persona-modal-child-example.component'
import {
  EditPersonaModalSelfContactInfoExampleComponent
} from './edit-persona-modal-docs/examples/edit-persona-modal-self-contact-info-example.component'
import { EditPersonaModalSelfExampleComponent } from './edit-persona-modal-docs/examples/edit-persona-modal-self-example.component'
import { PROVIDERS } from './providers'

@NgModule({
  declarations: [
    EditPersonaModalDocsComponent,
    EditPersonaModalChildExampleComponent,
    EditPersonaModalSelfContactInfoExampleComponent,
    EditPersonaModalSelfExampleComponent],
  imports: [
    CommonModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeDocsTableModule,
    SeFeHeaderModule,
    SeFePageModule,
    SharedFeatureEditPersonaModalModule
  ],
  exports: [EditPersonaModalDocsComponent],
  providers: PROVIDERS
})
export class SharedFeatureEditPersonaModalDocsModule {}
